var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"profileImage",attrs:{"src":_vm.photoURL,"width":"250","height":"250"}})])}
var staticRenderFns = []

export { render, staticRenderFns }